import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CrudForm from '../../crud/CrudForm'
import { disabledaysService as service } from '../../../services'
import { useTranslation } from 'react-i18next'

const initElement = {
    day: null,
    name: null,
    user: { id: null, name: '' },
    company: { id: null, name: '' },
}

export default function FormDisabledays(props) {
    const [objectform, setObjectform] = React.useState({ ...initElement })
    type FormParms = {
        id: string
        company: string
        user: string
        userc: string
    }
    const { t, i18n } = useTranslation()

    const [object, setObject] = useState({
        ...initElement,
    })

    const estructureform = [
        {
            type: 'input',
            name: 'day',
            inputtype: 'date',
            col: 4,
        },
        {
            type: 'input',
            name: 'name',
            col: 4,
        },
    ]

    const recoveryElement = function (objectedit, element) {
        return objectedit
    }

    const isValid = function (object) {
        return null
    }

    return (
        <>
            <CrudForm
                objectform={{
                    ...object,
                }}
                estructureform={estructureform}
                i18n={'disableday'}
                urledit={'/disabledays/edit/'}
                urlCancel={'/disabledays/'}
                service={service}
                recoveryElement={recoveryElement}
                valid={isValid}
            />
        </>
    )
}
